import React from 'react';
export default class releaseNotifications extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            businessJustification: '',
            serviceProviderName: '',
            formErrors: { email: '' },
            emailValid: false,
            formValid: false,
            message: null,
            disable: false,
            response: null,
            alert: false,
            success:false
        }
    }

handleSubmit = async (event) => {
    event.preventDefault();
    try {
        if (this.state.formValid) {
            this.setState({disable: true});
            const resp = await this.sendData();
            this.setState({ response: resp.status ? `${ resp.status } error occured` : "error occured" });// for failed to fetch url error
            let res = await resp.json(); // can throw err in case of no response
            if (resp.ok) {
                if (res && res.success === true) {
                    this.setState({response: 'Subscription request submitted successfully!'});
                    this.setState({success: true});
                    this.setState({alert: true});
                    this.clearData();
                } else if (res && res.errors) {
                    let message = res.message;
                    res.errors.forEach(element => {
                        message = message.concat(`\nField :${ element.field }, Error:${ element.message }.`)
                    })
                    this.setState({response: res.message});
                    this.setState({alert: true});
                } else {
                    let data = res && res.message ? res.message : "Error occured";
                    this.setState({response: data});
                    this.setState({alert: true});
                }
            } else {
                this.setState({
                    response: res && res.message ? `${res.message}` : (resp.status ? `${resp.status} error occured` : `Error occured`)
                });
                this.setState({alert: true});
            }
            this.clearData();
            this.setState({disable: false});
        } else {
            this.setState({message: this.state.emailValid});
            this.setState({response: this.state.message}); // if form not valid, the message is stored in this.state.message
            this.setState({alert: true});
            this.clearData();
            this.setState({disable: false});
        }
    } catch (err) {
        this.setState({alert: true});
        this.clearData();
        this.setState({disable: false});
    }
}

clearData = () => {
    this.setState({email: ''});
    this.setState({businessJustification: ''});
    this.setState({serviceProviderName: ''});
}

sendData = async () => {
    const options = {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {businessJustification: this.state.businessJustification, email: this.state.email, serviceProviderName: this.state.serviceProviderName}
        )
    }
    const url = `${window.location.origin}/api/v1/subscriptions`;
    return await fetch(url, options).then(function (response) {
        return response;
    }).catch(function (err) {
        return err.message;
    });
}

handleUserInput = (e) => {
    this.setState({alert: false});
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
        this.validateField(name, value)
    });
}

validateForm() {
    this.setState({formValid: this.state.emailValid});
}

validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;

    switch (fieldName) {
        case 'email': emailValid = (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.[a-zA-Z]{2,})+$/i).test(value)
            fieldValidationErrors.email = emailValid ? '' : `Invalid email`;
            break;
        default:
            break;
    }
    this.setState({
        formErrors: fieldValidationErrors,
        emailValid: emailValid,
        message: fieldValidationErrors.email
    }, this.validateForm);
}

render() {
    const { disable, alert, response, success } = this.state;
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <form onSubmit={this.handleSubmit} >
                <div className="bootstrap-scope">
                    <div className="mt-5">
                        <div className="form-title" >
                            <div className="row">
                                <div className="mb-4">
                                    <h2 id='title'><strong>Release Notes Subscription</strong></h2>
                                </div>
                            </div>
                            {alert ? success? <div className="row mb-4 alert alert-success">{response}
                            </div>:<div className="row mb-4 alert alert-danger">{response}
                            </div> : <div></div>}
                        </div>
                        <div className="form-group required">
                            <label className="label-form">Email Address: <span style={{ color: "red" }} ><sup>*</sup></span></label>
                            <div className="row">
                                <input type="email" name="email" placeholder='name@example.com' style={{ width: "400px" }}
                                    value={this.state.email}
                                    onChange={this.handleUserInput} required disabled={this.state.disable} />
                            </div>
                        </div>
                        <div className="form-group serviceProviderName">
                            <label className="label-form">Service Provider Name: </label>
                            <div className="row">
                                <input type="text" name="serviceProviderName" style={{ width: "400px" }}
                                    value={this.state.serviceProviderName}
                                    onChange={this.handleUserInput} disabled={this.state.disable} />
                            </div>
                        </div>
                        <div className="form-group businessJustification">
                            <label className="label-form">Business Justification: </label>
                            <div className="row">
                                <textarea className="text-area" name="businessJustification" rows="3" style={{ width: "400px" }}
                                    value={this.state.businessJustification}
                                    onChange={this.handleUserInput} disabled={this.state.disable} ></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="text-right">
                        {disable ? <button type="submit" className="btn btn-primary" disabled={this.state.disable}>Submitting...</button>
                            : <button type="submit" className="btn btn-primary" disabled={this.state.disable}>Submit</button>}
                    </div>
                </div>
            </form>
        </div>
    )
}
}
